import { changeLogoColor, changeTextColor } from '../../logics';
import { colorType, logoEditingStatusEnum } from '../../../utils/constants';
import { updateImageColorByLogoColor, updateTextColorByLogoColor } from '../../../nextgen/Upload/logics';

import { changeLogoEditingStatus } from '../../../main/actions';
import { changeNextgenUiStatus } from '../../../nextgen/actions';
import { nextGenFlyoutPanelEnum } from '../../../nextgen/constants';
import { rgbToCMYK } from '../../../utils';

export const applyLogoColorPicker = (params) => {
  const { dispatch, canvasKey, colorSelected, oldColor, isTextColor } = params;

  if (colorSelected.color.colorType === colorType.Pms && colorSelected.color.colorReference === '') return;

  if (colorSelected.success && colorSelected.color && colorSelected.color.colorId !== oldColor.colorId) {
    const newColor = colorSelected.color;

    if (isTextColor) {
      changeTextColor(dispatch, canvasKey, newColor, false);
    } else
      changeLogoColor({
        ...params,
        newColor,
        isChangingColor: false,
      });
  }

  dispatch(changeLogoEditingStatus(logoEditingStatusEnum.NonDigitalLogoColor));
  dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.LogoColorPanel } }));
};

export const cancelLogoColorPicker = (params) => {
  const { dispatch, canvasKey, originColor, colorClicked, isTextColor } = params;

  if (colorClicked.colorId !== originColor.colorId) {
    if (isTextColor) {
      changeTextColor(dispatch, canvasKey, originColor);
    } else {
      changeLogoColor({
        ...params,
        callback: () => {
          if (params.isMultipleArtMultipleColor) {
            dispatch(
              updateTextColorByLogoColor({ formatkey: canvasKey, oldColor: colorClicked, newColor: originColor })
            );
            dispatch(
              updateImageColorByLogoColor({
                formatkey: canvasKey,
                oldColor: colorClicked,
                newColor: originColor,
                ...params,
              })
            );
          }
        },
      });
    }
  }

  dispatch(changeLogoEditingStatus(logoEditingStatusEnum.NonDigitalLogoColor));
  dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.LogoColorPanel } }));
};

export const changeColorInLogoColorPicker = (params) => {
  const { dispatch, canvasKey, colorSelected, oldColor, isTextColor, isChangingColor } = params;

  if (colorSelected.color.colorType === colorType.Pms && colorSelected.color.colorReference === '') return;

  if (colorSelected.success && colorSelected.color && colorSelected.color.colorId !== oldColor.colorId) {
    const newColor = colorSelected.color;

    if (isTextColor) {
      changeTextColor(dispatch, canvasKey, newColor, isChangingColor);
    } else {
      changeLogoColor({
        ...params,
        newColor,
        isChangingColor,
        callback: () => {
          if (params.isMultipleArtMultipleColor) {
            dispatch(updateTextColorByLogoColor({ formatkey: canvasKey, oldColor, newColor }));
            dispatch(updateImageColorByLogoColor({ formatkey: canvasKey, oldColor, newColor, ...params }));
          }
        },
      });
    }
  }
};

export const fillColorCmyk = (newColors, colorList) => {
  newColors.forEach((color) => {
    const origin = colorList.find((c) => c.colorReference === color.colorReference);
    if (origin) {
      color.cmyk = origin.cmyk || rgbToCMYK(origin.colorReference);
      color.colorType = origin.colorType;
    }
  });
};
